let applicationList = [
  
  {
    applicationId: "pc-gjjdkjdcxttyjk",
    text: "公积金贷款进度查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjjhdjlcxxmvap",
    text: "公积金还贷记录查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjjtqjlcxlxxka",
    text: "公积金提取记录查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjtqjdcxvnovp",
    text: "公积金提取进度查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjjcjlcxudcjj",
    text: "公积金缴存记录查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjjjcxxcxmxqdt",
    text: "公积金缴存信息查询",
    userType: 1,
  },
  {
		applicationId: "pc-gjjyddkzmdyyqqsa",
		text: "公积金异地贷款证明打印",
		print: true,
		userType: 1
	},
  {
		applicationId: "pc-gjjzxxxcxjpbpm",
		text: "公积金中心信息查询",
		userType: 1
	},
	{
		applicationId: "pc-gjjhzlpcxwgcla",
		text: "公积金合作楼盘查询",
		userType: 1
	},
  {
		applicationId: "pc-gjjywwdcxwiruu",
		text: "公积金业务网点查询",
		userType: 1
	},
  {
		applicationId: "pc-gjjdkxxcxnymin",
		text: "公积金贷款信息查询",
		userType: 1
	},
  {
		applicationId: "pc-dqgjjjczmdyphyzd",
		text: "大庆公积金缴存证明打印",
		userType: 1,
		print: true
	},
  
];
let applicationName = "公积金中心信息查询";
export default {
  applicationName,
  applicationList,
};
